// Etiqueta de unidad de producción en la UI (propuesta 2026-10-alimentos-rionegro).
//
// El API manda `unidad` opcional ('paq' | 'kg') derivada de skus.formato. Si no
// viene (respuesta previa o tenant sin SKUs a granel), se muestra "paq" como
// siempre.

import { unidadDeFormato, type UnidadMedida } from 'schemas';

export type { UnidadMedida };

/** Unidad a mostrar: la que manda el API o "paq" si no viene. */
export function etiquetaUnidad(unidad: UnidadMedida | null | undefined): UnidadMedida {
  return unidad ?? 'paq';
}

/** Unidad de un SKU por su formato (GRANEL → kg). */
export function unidadDeSku(sku: { formato?: string | null } | null | undefined): UnidadMedida {
  return unidadDeFormato(sku?.formato);
}
